export const AccountType = {
  CUSTOMER: 'CUSTOMER',
  VENDOR: 'VENDOR',
  UNKNOWN: 'UNKNOWN',
};
